var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"32","height":"32","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M23.015 3.995a1 1 0 00-1.717-.697l-12 12a1 1 0 000 1.414l12 12a1 1 0 101.414-1.414L11.419 16.005 22.712 4.712a1 1 0 00.303-.717z","fill":"#1D232D","fill-rule":"nonzero"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }